import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import usePermissions from "hooks/usePermissions";
import { useTestNotification, useTriggerSecurityEventNotification } from "security-app/hooks/useSecurityEventsAPI";
import StepActionButton from "./StepActionButton";
function StepSendNotification({ step, eventId = void 0 }) {
  const { t } = useTranslation("enterprise_security_events");
  const { notification_id } = step.action.config;
  const { isPermitted } = usePermissions();
  const disabled = !isPermitted(`eventnotifications:edit:${notification_id}`);
  const { triggerSecurityEventNotification, triggeringSecurityEventNotification } = useTriggerSecurityEventNotification();
  const { testNotification, testingNotification } = useTestNotification();
  const onClick = useCallback(() => {
    if (eventId) {
      triggerSecurityEventNotification({ id: eventId, notificationId: notification_id, stepId: step.id });
    } else {
      testNotification({ id: notification_id });
    }
  }, [eventId, triggerSecurityEventNotification, notification_id, step.id, testNotification]);
  return /* @__PURE__ */ React.createElement(
    StepActionButton,
    {
      hint: disabled ? t("step_send_notification.hint_no_access") : void 0,
      title: eventId ? t("step_send_notification.run") : t("step_send_notification.test"),
      onClick: disabled ? null : onClick,
      disabled: disabled || triggeringSecurityEventNotification || testingNotification
    }
  );
}
export default StepSendNotification;
